import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConnectedMultiSelect from './MultiSelect';
import MultiRecipientSelect from '../MultiRecipientSelect';
import { getRecipientName } from '../../ui/collections/Recipient';

function ConnectedMultiRecipientSelect({ requiredFieldError, ...props }) {
  const { t } = useTranslation(['commonPlat', 'sMgmt']);

  // Temporary exclusion list so we don't need to re-fetch the entire list when hiding
  const [exclude, setExclude] = useState([]);

  const handleHide = (item) => {
    props.api.makeRequest(`/user/message-target/${item.targetRel}`, 'DELETE', {}, (err, res) => {
      if (!err && res.ok) {
        props.onHide?.(item);
        setExclude([...exclude, item.targetRel]);
      }
    });
  };

  const handleAction = (item, action, params) => {
    if (action === 'hide') {
      return handleHide(item);
    }
  };

  return (
    <ConnectedMultiSelect
      {...props}
      requiredFieldError={requiredFieldError || t('commonPlat:errors.multiRecipientField')}
      primaryKey="targetRel"
      dataPath="root"
      dataMapper={(data) => {
        // Pre-translate and format the label, keeping its options
        const [label, allowHide] = getRecipientName(data, t);
        return {
          ...data,
          label,
          allowHide,
        };
      }}
      excludeValues={exclude}
      onAction={handleAction}
      endpoint={(value) => `/user/message-targets?query=${encodeURIComponent(value)}`}
      component={MultiRecipientSelect}
      limitSelectedAreaHeight
      preload
    />
  );
}

ConnectedMultiRecipientSelect._hookable = true;

export default ConnectedMultiRecipientSelect;
